import React, { useEffect, useState, useRef } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useNavigate } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewAnnouncements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = config.token;
  const navigate = useNavigate();

  //  ------For TableViewer ------
  const announcementsRef = useRef([]);
  announcementsRef.current = announcements;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  //----------------------------------------------- select / view announcements table  -------------------------------------------------R
  // Fetch all courses
  const fetchAnnouncement = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}announcement`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Successful response, update the courses state
            setAnnouncements(data.data);
            // console.log(data.data);

            //  ------For TableViewer ------
            const announcementsData = data.data.map((announcement) => ({
              title: announcement.title,
              idNumber: announcement.aid,
            }));
            setRowData(announcementsData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching announcement.");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchAnnouncement();
  }, [token]);

  // ------------------------------------------------- Edit / Update announcement ----------------------------------------------------U
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addannouncement/${encodedId}`);
  };

  // ---------------------------------------------------- Delete Announcement ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete Announcement. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteAnnouncement(deleteId, i);
      }
    });
  };

  //If confirm then delete Announcement
  const handleDeleteAnnouncement = async (deleteId, i) => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}announcement/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "Announcement deleted successfully."
            );

            //  ------For TableViewer ------
            const updatedAnnouncement = [...announcementsRef.current];
            updatedAnnouncement.splice(i, 1);
            setAnnouncements(updatedAnnouncement);

            const announcementsData = updatedAnnouncement.map(
              (announcement) => ({
                title: announcement.title,
                idNumber: announcement.aid,
              })
            );
            setRowData(announcementsData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error deleting teacher");
    }
    setLoading(false);
  };

  //----------------------------------------------- select / view single announcement -------------------------------------------------R
  const btnShowHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/viewannouncement/${encodedId}`);
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "title", filter: true },
  ];
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage Announcement" subpath={["View Announcements"]} />

      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center  row flex justify-between">
            <h5 className="mb-0 col-sm-3 ">View Announcements</h5>
            <button
              type="button"
              className="btn btn-primary col-sm-2 mr-2 mt-2"
              onClick={() => {
                navigate("/addannouncement");
              }}
            >
              Add Announcement
            </button>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
                onView={btnShowHandle}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewAnnouncements;
